var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M51.4002 31.8249C50.4752 31.8249 49.7002 31.1249 49.6002 30.1999C49.0002 24.6999 46.0502 19.7499 41.5002 16.5999C40.6752 16.0249 40.4752 14.8999 41.0502 14.0749C41.6252 13.2499 42.7502 13.0499 43.5752 13.6249C49.0002 17.3999 52.5002 23.2999 53.2252 29.8249C53.3252 30.8249 52.6002 31.7249 51.6002 31.8249C51.5252 31.8249 51.4752 31.8249 51.4002 31.8249Z",
    fill: "#004192"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.85023 31.9499C9.80023 31.9499 9.72523 31.9499 9.67523 31.9499C8.67523 31.8499 7.95023 30.9499 8.05023 29.9499C8.72523 23.4249 12.1752 17.5249 17.5502 13.7249C18.3502 13.1499 19.5002 13.3499 20.0752 14.1499C20.6502 14.9749 20.4502 16.0999 19.6502 16.6749C15.1502 19.8749 12.2252 24.8249 11.6752 30.2999C11.5752 31.2499 10.7752 31.9499 9.85023 31.9499Z",
    fill: "#004192"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M40.475 52.7499C37.4 54.2249 34.1 54.9749 30.65 54.9749C27.05 54.9749 23.625 54.1749 20.425 52.5499C19.525 52.1249 19.175 51.0249 19.625 50.1249C20.05 49.2249 21.15 48.8749 22.05 49.2999C23.625 50.0999 25.3 50.6499 27 50.9749C29.3 51.4249 31.65 51.4499 33.95 51.0499C35.65 50.7499 37.325 50.2249 38.875 49.4749C39.8 49.0499 40.9 49.3999 41.3 50.3249C41.75 51.2249 41.4 52.3249 40.475 52.7499Z",
    fill: "#004192"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6252 5.02502C26.7502 5.02502 23.5752 8.17502 23.5752 12.075C23.5752 15.975 26.7252 19.125 30.6252 19.125C34.5252 19.125 37.6752 15.975 37.6752 12.075C37.6752 8.17502 34.5252 5.02502 30.6252 5.02502Z",
    fill: "#004192"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1252 34.675C9.2502 34.675 6.0752 37.8251 6.0752 41.7251C6.0752 45.6251 9.2252 48.775 13.1252 48.775C17.0252 48.775 20.1752 45.6251 20.1752 41.7251C20.1752 37.8251 17.0002 34.675 13.1252 34.675Z",
    fill: "#004192"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8752 34.675C44.0002 34.675 40.8252 37.8251 40.8252 41.7251C40.8252 45.6251 43.9752 48.775 47.8752 48.775C51.7752 48.775 54.9252 45.6251 54.9252 41.7251C54.9252 37.8251 51.7752 34.675 47.8752 34.675Z",
    fill: "#004192"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.fdd905dba18f64794f8070e1c2ef4df0.svg";
export { ForwardRef as ReactComponent };